goog.provide("shadow.js.shim.module$$mui$material$Alert$default");
shadow.js.shim.module$$mui$material$Alert$default = shadow.js.require(395, {})["default"];
